import * as React from 'react';
import { styled } from '../theme-provider';
import { createCSSVariablesForSizes, createHorizontalAlignmentStyles, createSpacingAroundElementsStyles, createSpacingBetweenElementsStyles, createWrapStyles, } from './helpers';
import { createElectricTransition } from '../helpers/animation';
import { createStylesForBreakpoints, } from '../helpers/breakpoint';
import { getCommonProps } from '../helpers/common-props';
const createStretchContentForBreakpoints = (props) => {
    if (!props.stretchContent) {
        return '';
    }
    return createStylesForBreakpoints(props.stretchContent, (stretchContent) => stretchContent ? 'flex-grow: 1;' : 'flex-grow: initial;');
};
const createShrinkContentForBreakpoints = (props) => {
    if (!props.shrinkContent) {
        return '';
    }
    return createStylesForBreakpoints(props.shrinkContent, (shrinkContent) => shrinkContent ? 'flex-shrink: 1;' : 'flex-shrink: initial;');
};
const StyledChildWrapper = styled.div.withConfig({ displayName: "StyledChildWrapper", componentId: "sc-1d21nde" }) `flex-shrink:0;max-width:100%;${createStretchContentForBreakpoints};${createShrinkContentForBreakpoints};${createSpacingBetweenElementsStyles};:empty{display:none;}`;
StyledChildWrapper.displayName = 'StyledChildWrapper';
const StyledOverflowWrapper = styled.div.withConfig({ displayName: "StyledOverflowWrapper", componentId: "sc-mfnmbg" }) `overflow:${(props) => (props.wrapChildren ? '' : 'hidden')};`;
StyledOverflowWrapper.displayName = 'StyledOverflowWrapper';
// `flex-grow: 1;` for stretchContent is needed for cases where the content does not bring its own width and instead relies on the width
// of the container. Combined with the container being inside a different flex element.
// Example: <Layout><Container stretchContent><AspectRatioContainer /></Container></Layout>
// Also see "components-cms/mood-gallery"
//
// To use transition for some properties:
// animateChange={['padding', 'opacity']}
const StyledContainer = styled.div.withConfig({ displayName: "StyledContainer", componentId: "sc-18harj2" }) `${(props) => props.gutter && createCSSVariablesForSizes(props.gutter, props.theme)} ${(props) => props.padding && createCSSVariablesForSizes(props.padding, props.theme)} ${(props) => createWrapStyles(props.theme, props.gutter, props.wrapChildren)} align-items:${(props) => props.verticalAlign};${(props) => props.horizontalAlign &&
    createHorizontalAlignmentStyles(props.horizontalAlign)} ${(props) => props.padding &&
    createSpacingAroundElementsStyles(props.padding, props.theme)};${(props) => props.animateChange && createElectricTransition(...props.animateChange)};`;
StyledContainer.displayName = 'StyledContainer';
const ContainerInner = (props) => {
    const { children, gutter, padding, wrap, stretchContent, shrinkContent, verticalAlign, horizontalAlign, animateChange, innerRef, } = props;
    const commonProps = getCommonProps(props);
    const childElements = React.Children.toArray(children).filter(React.isValidElement);
    if (childElements.length === 0) {
        return null;
    }
    return (React.createElement(StyledOverflowWrapper, Object.assign({ ref: innerRef, wrapChildren: wrap }, commonProps),
        React.createElement(StyledContainer, { gutter: gutter, padding: padding, wrapChildren: wrap, verticalAlign: verticalAlign, horizontalAlign: horizontalAlign, animateChange: animateChange }, childElements.map((child) => {
            const key = child.key === null ? undefined : child.key;
            return (React.createElement(StyledChildWrapper, { key: key, gutter: gutter, wrapped: wrap, stretchContent: stretchContent, shrinkContent: shrinkContent }, child));
        }))));
};
export const Container = React.forwardRef((props, ref) => React.createElement(ContainerInner, Object.assign({}, props, { innerRef: ref })));
Container.displayName = 'Container';
